<template>
  <md-card>
    <vc-calendar
      is-expanded
      locale="es"
      mode="range"
      :attributes='attributes'
      :value="null"
      color="red"
      is-dark
      popover.placement="auto"
      @update:from-page="pageChange"
      is-inline
    />
  </md-card>
</template>

<script>
import axios from "axios";
import Global from "../../Global";
// Or just use in separate component
export default {
    data() {
    return {
      attributes: [],
      url: Global.url
    };
  },
  methods: {
      pageChange (obj) {
        var fecha = new Date(obj.year, obj.month - 1, 1)
        var fechahasta = new Date(obj.year, obj.month, 0)

        this.getPedidos(fecha, fechahasta)

      },


      getPedidos(fecha, fechahasta) {
        axios
            .get(
              this.url + "pedido/get/calendario/"+this.$moment(fecha).format("Y-MM-DD") +"/"+this.$moment(fechahasta).format("Y-MM-DD"),
              {
                headers: { ApiToken: localStorage.usertoken }
              }
            )
            .then(res => {

                var obj = res.data;
                var att = [];

                obj.forEach( function(valor, indice, array) {
                    var color = 'green';

                    switch (valor.estado) {
                        case 'pendiente':
                            color = 'yellow'
                            break;
                        case 'entregado':
                            color = 'green'
                            break;
                        case 'postergado':
                            color = 'pink'
                            break;
                    }

                    att.push({
                        dot: {
                            color: color,
                        },
                        dates: [
                            valor.fecha
                        ],
                        popover: {
                            label:  valor.nombre+ ' (' + valor.hora.substr(0,5) + ')',
                        },
                    })

                });

                this.attributes = att;
            })
        }
    }
};
</script>